import { render, staticRenderFns } from "./rulers.vue?vue&type=template&id=2f3ee9b4&scoped=true&"
import script from "./rulers.vue?vue&type=script&lang=js&"
export * from "./rulers.vue?vue&type=script&lang=js&"
import style0 from "./rulers.vue?vue&type=style&index=0&id=2f3ee9b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3ee9b4",
  null
  
)

export default component.exports